import React from 'react';
import { ImageOptionalLink } from '../../commonTypes/links';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import { Background, LinkWrapper, LogoLinkWrapper, StyledLogo } from './styles';

export type LogoLinkProps = {
  logoLink: ImageOptionalLink;
  shouldEagerLoad?: boolean;
  background?: Background;
  hideFromScreenReaders?: boolean;
} & ComponentProps;

const LogoLink: React.FC<LogoLinkProps> = ({
  logoLink: { link, image },
  shouldEagerLoad,
  background,
  hideFromScreenReaders,
  ...props
}) => (
  <LogoLinkWrapper {...componentProps(props)}>
    {link ? (
      <LinkWrapper
        href={link.url}
        role="link"
        onClick={link.onClick}
        aria-label={hideFromScreenReaders ? undefined : link.screenReaderText}
        background={background ?? 'light'}
        aria-hidden={hideFromScreenReaders}
        tabIndex={hideFromScreenReaders ? -1 : undefined}>
        <StyledLogo
          src={image.url}
          alt={image.altText}
          height={image.height}
          width={image.width}
          shouldEagerLoad={shouldEagerLoad}
          focusable={false}
        />
      </LinkWrapper>
    ) : (
      <StyledLogo src={image.url} alt={image.altText} shouldEagerLoad={shouldEagerLoad} />
    )}
  </LogoLinkWrapper>
);

export default applyComponentTheme(LogoLink, 'LogoLink');
